import { useState } from "react";
import { Link } from "react-router-dom";
import S from "./style";
import TranslateStatic from "../../locales/TranslateStatic";

const videoList = [
  { id: "RYDLFBW-bEI", title: "Surgical Hysteroscopy Was Performed As An Ambulatory Procedure Under General Anesthesia" },
  { id: "5AZsOKrjQjw", title: "Hysteroscopic Correction Of A Septate Uterus With Two Cervical Ostia" },
  { id: "zvXHznpUN-s", title: "Hysteroscopic Correction Of Subseptum Uteri In Two Cases" },
  { id: "iBlpNq6CG_M", title: "Hysteroscopic Removal Of An Unusual Foreign Object" },
  { id: "V7ersAlfYEI", title: "HS Correction Of Complete Septum" },
  { id: "oUigN07IWJY", title: "Hysteroscopic Excision Of Sessile Submuccous Mynoma" },
  { id: "qc8AlpY-KGM", title: "Asherman Syndrome Hysteroscopic Adhesiolysis" }
];

export function Ameliyatlar() {
  const [activeVideo, setActiveVideo] = useState(null);

  const renderVideos = () => {
    return (
      <div className="mapContainer">
        {videoList.map((vid, index) => (
          <div key={index} className="video-card" onClick={() => setActiveVideo(vid.id)}>
            <div className="iframe-wrapper">
              <img src={`https://img.youtube.com/vi/${vid.id}/hqdefault.jpg`} alt={vid.title} />
              <div className="gradient-overlay"></div>
              <div className="play-button-overlay">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              <div className="video-title">
                <h3>{vid.title}</h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="Ameliyatlar" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="Ameliyatlar" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="gallery-container">
          <div className="intro-text">
            <p><TranslateStatic string="IlacAnlatimiMetin" /></p>
          </div>

          {renderVideos()}
        </div>
      </S.ContentWrapper>

      {activeVideo && (
        <S.ModalOverlay onClick={() => setActiveVideo(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setActiveVideo(null)}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
            <div className="modal-video-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </S.ModalOverlay>
      )}
    </S.PageWrapper>
  );
}
